import React, { useContext, useState, useEffect } from "react";
import { QuoteContext } from "./QuoteContext";
import { motion } from "framer-motion";

const Coverage = () => {
  const { formValues, updateFormValues, nextStep, prevStep, step } = useContext(QuoteContext);
  
  // Initialize state with stored form values
  const [selectedCoverage, setSelectedCoverage] = useState(formValues.coverage || "");
  const [familyMembers, setFamilyMembers] = useState(formValues.familyMembers || 2);
  const [error, setError] = useState("");
  const [familyError, setFamilyError] = useState("");

  useEffect(() => {
    // Preserve selected coverage from formValues (don't force 'individual')
    setSelectedCoverage(formValues.coverage || "individual");
    setFamilyMembers(formValues.familyMembers || 2);
  }, [step]);

  const handleSelection = (type) => {
    setSelectedCoverage(type);
    updateFormValues({ coverage: type });

    if (type === "individual") {
      setFamilyMembers(2); // Reset to 2 instead of empty
      setFamilyError("");
      updateFormValues({ familyMembers: "" });
    }
  };

  const handleNext = () => {
    if (!selectedCoverage) {
      setError("Please select an option to continue.");
      return;
    }

    if (selectedCoverage === "family" && (!familyMembers || parseInt(familyMembers) < 2)) {
      setFamilyError("Minimum 2 family members required.");
      return;
    }

    updateFormValues({ familyMembers: parseInt(familyMembers) });
    nextStep();
  };

  return (
    <div className="text-orangeColor px-2 flex items-center bg-[#001F3F]">
      <div className="max-w-[500px] mx-auto mt-16">
      <div className="text-white text-[12px] mb-6">
  <span className="bg-[#1f4c75] font-thin px-4 py-1 rounded-full  pointer-events-none cursor-not-allowed">
    Coverage
  </span>
</div>

        
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">Who Needs Coverage?</h1>
        <p className="mb-16 text-[#dfdfdf]">Select an option to continue</p>

        <div className="flex justify-center gap-3 sm:gap-6  md:gap-10 mt-8">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={`cursor-pointer border-2 ${
              selectedCoverage === "individual" ? "border-orangeColor bg-[#0c3c5f]" : "border-transparent bg-[#0c3c5f]"
            } text-white font-[500] text-sm sm:text-[18px] md:text-[20px] p-4 w-[160px] sm:w-[200px] h-[100px] sm:h-[120px] md:w-[240px] md:h-[150px] rounded-xl text-center flex items-center justify-center gap-2`}
            onClick={() => handleSelection("individual")}
          >
            <img src="/images/stepform/justme.png" alt="Just Me" className="md:h-20 h-16 md:w-20 w-16 object-contain" />
            <p>Just Me</p>
          </motion.div>

          {/* Family Option */}
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.1 }}
            className={`cursor-pointer border-2 ${
              selectedCoverage === "family" ? "border-orangeColor bg-[#0c3c5f]" : "border-transparent bg-[#0c3c5f]"
            } text-white font-[500] text-sm sm:text-[18px] md:text-[20px] p-4 w-[160px] sm:w-[200px] h-[100px] sm:h-[120px] md:w-[240px] md:h-[150px]  rounded-xl text-center flex items-center justify-center `}
            onClick={() => handleSelection("family")}
          >
            <img src="/images/getemail/myFamily.png" alt="My Family" className="md:h-[70px] h-[60px] md:w-20 w-16 object-contain pl-5" />
            <p className="w-full">My Family</p>
          </motion.div>
        </div>

        {error && <p className="text-red-500 mt-2">{error}</p>}

        {/* Family Members Dropdown */}
        {selectedCoverage === "family" && (
          <div className="mt-8">
            <p className="text-[#dfdfdf]">How many members?</p>
            <select
              className="mt-4 bg-[#01344D] w-full rounded-xl text-white border-white border p-2"
              value={familyMembers}
              onChange={(e) => {
                const value = parseInt(e.target.value);
                setFamilyMembers(value);
                setFamilyError(value < 2 ? "Minimum 2 family members required." : "");
              }}
            >
              {Array.from({ length: 9 }, (_, i) => i + 2).map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            {familyError && <p className="text-red-500 mt-2">{familyError}</p>}
          </div>
        )}

        <div className="flex justify-end">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleNext}
            className="bg-orangeColor text-white mt-8 py-3 md:py-3 md:px-6 px-4 rounded-xl  hover:bg-[#ff9800] transition-all"
          >
            Next Step →
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Coverage;

